import { render, staticRenderFns } from "./ModuloDeInfusao.vue?vue&type=template&id=4fa251a8&"
import script from "./ModuloDeInfusao.vue?vue&type=script&lang=js&"
export * from "./ModuloDeInfusao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports